/**
 * Studio Builder — App Shell
 *
 * 3-mode workflow layout:
 *   Toolbar (top) → Sidebar (left) + Canvas (center)
 * Modals managed via store.openModal.
 * Theme + Keyboard via hooks.
 */
import { useBuilderTheme } from '@/hooks/useBuilderTheme';
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts';
import { Toolbar } from '@/components/editor/Toolbar';
import { Sidebar } from '@/components/editor/Sidebar';
import { PreviewCanvas } from '@/components/PreviewCanvas';
import { ModalContainer } from '@/components/ModalContainer';

export function App() {
  useBuilderTheme();
  useKeyboardShortcuts();

  return (
    <div className="sb-layout">
      <Toolbar />
      <div className="sb-body">
        <Sidebar />
        <PreviewCanvas />
      </div>
      <ModalContainer />
    </div>
  );
}
